// How the Setup tab reads the catalog of GET /admin/tournament-feedback/catalog (sportya-api docs/tournament-feedback.md).

export const LANGUAGES = [["en", "English", "EN"], ["bg", "Bulgarian", "BG"]]
// An item's Romanian texts that have English and Bulgarian variants: [field, name in the messages, key in `limits`].
export const THEME_FIELDS = [["title", "title", "title"], ["reasonsLabel", "reasons label", "reasonsLabel"]]
export const REASON_FIELDS = [["text", "text", "reason"]]

export const isActive = item => item?.status === "active"
export const variantText = (variant, field) => {
  const text = variant?.content?.[field]
  return typeof text === "string" && text ? text : null
}

// Why an item cannot be activated yet, or null: every variant translated, present and within its field's limit.
export function notReady(item, fields, limits) {
  for (const [field, name, limitKey] of fields) {
    for (const [language, languageName] of LANGUAGES) {
      const variant = item.variants?.[language]
      const text = variantText(variant, field)
      if (variant?.status === "pending") return "Not ready: translation in progress."
      if (!text || variant.status === "manualRequired") return `Not ready: write the ${languageName} ${name} by hand.`
      if (text.length > limits[limitKey] || variant.status === "tooLong") {
        return `Not ready: the ${languageName} ${name} has ${text.length}/${limits[limitKey]} characters. Correct it by hand.`
      }
    }
  }
  return null
}

// „To check” on a theme's strip: one of its own texts or of its reasons' texts is not ready.
export const themeToCheck = (theme, limits) => !!notReady(theme, THEME_FIELDS, limits)
  || theme.reasons.some(item => !!notReady(item, REASON_FIELDS, limits))

const DAY = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Bucharest", day: "numeric", month: "short", year: "numeric" })
export const day = iso => {
  const date = iso ? new Date(iso) : null
  return date && !Number.isNaN(date.getTime()) ? DAY.format(date) : null
}
